import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["innerRef"];
import styled from 'styled-components';
import { DragDropContext } from 'react-beautiful-dnd';
import { jsx as _jsx } from "react/jsx-runtime";
const BoardContainer = styled.div.withConfig({
  displayName: "DroppableBoard__BoardContainer",
  componentId: "usaeqc-0"
})(["height:100%;overflow:auto;"]);
BoardContainer.displayName = 'StyledScrollContainer';
const StyledDiv = styled(_ref => {
  let {
      innerRef
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({
    ref: innerRef
  }, rest));
}).withConfig({
  displayName: "DroppableBoard__StyledDiv",
  componentId: "usaeqc-1"
})(["height:100%;"]);
const DroppableBoard = ({
  children,
  onDragEnd,
  onDragStart
}) => {
  return /*#__PURE__*/_jsx(BoardContainer, {
    "data-test-id": "cdb-board-container",
    children: /*#__PURE__*/_jsx(DragDropContext, {
      onDragEnd: onDragEnd,
      onDragStart: onDragStart,
      children: /*#__PURE__*/_jsx(StyledDiv, {
        children: children
      })
    })
  });
};
export default DroppableBoard;